import { GraphQLError, GraphQLScalarType, Kind } from "graphql";

//#region src/custom-scalars/npi.scalar.ts
const NPI_REGEX = /^\d{10}$/;
const npiScalar = new GraphQLScalarType({
	name: "NPI",
	description: "NPI custom scalar type",
	serialize: (value) => {
		if (!(typeof value === "string")) throw new GraphQLError(`GraphQL serializer expected a 'string' but got ${typeof value}.`, { extensions: { code: "400" } });
		return isNpi(value);
	},
	parseValue: (value) => {
		if (!(typeof value === "string")) throw new GraphQLError(`GraphQL parser expected a 'string' but got ${typeof value}.`, { extensions: { code: "400" } });
		return isNpi(value);
	},
	parseLiteral: (ast) => {
		if (ast.kind === Kind.STRING) return ast.value.toString();
		throw new GraphQLError(`GraphQL parser expected a 'string'.`, { extensions: { code: "400" } });
	}
});
function isNpi(value) {
	if (!NPI_REGEX.test(value)) throw new GraphQLError(`Provided value: ${value}, is not a valid npi.`, { extensions: { code: "BAD_USER_INPUT" } });
	return value;
}

//#endregion
export { npiScalar };